import { Component, Input } from '@angular/core';
import { IxBaseLookupComponent } from 'ix-ng-components';
import { RowsLookupDTO } from './rows-lookup.model';
import { Language } from '../../../vpoglednik/vpoglednik.enum';

@Component({
  selector: 'lib-rows-lookup',
  template: `
    <header class="{{ this.lookupClass }}">
      <div class="lookup-header flex-wrap">
        <div class="col-12" style="word-break:break-word;">{{ this.lookupHeader }}</div>
      </div>
    </header>
    @if (!this.header) {
      <div class="lookup-body flex-wrap">
        <div class="col-12" style="word-break:break-word;">
          {{ this.language === Language.EN ? item.numberOfRowsAng : item.numberOfRows }}
        </div>
      </div>
    }
  `,
})
export class RowsLookupComponent extends IxBaseLookupComponent {
  @Input()
  override item!: RowsLookupDTO;
  @Input()
  public lookupHeader?: string;
  @Input()
  public sifraHeader?: string;
  @Input()
  public language?: Language;
  protected readonly Language = Language;
}
